module.exports = __webpack_public_path__ + "media/recipes/56-be143279.png";